export default function getAdminBarHeight({ node }) {
  let nodeHeight = 0;

  if (!node) {
    return nodeHeight;
  }

  const styles = getComputedStyle(node);

  if (styles.position === 'fixed') {
    nodeHeight = node.offsetHeight;
  }

  if (styles.position === 'absolute' && window.scrollY <= node.offsetHeight) {
    nodeHeight = node.offsetHeight;
  }

  return nodeHeight;
}
